import { MiaPlaza } from "@/Reinforced.Typings";

export interface ISubjectFilteringOptionsWithState extends MiaPlaza.Control.Vue.Lists.Searchable.ISubjectFilteringOptions {
	Disabled: boolean;
	CourseOptions: ICourseFilteringOptionsWithState[];
}

export interface ICourseFilteringOptionsWithState extends MiaPlaza.Control.Vue.Lists.Searchable.ICourseFilteringOptions {
	Disabled: boolean;
}

// This two enums values shouldn't collide with each other
export enum SubjectDropDownOptionState {
	Selected = 0,
	Unselected = 1,
	Disabled = 2
}

export enum SeparatorOption {
	Separator = 3
}

export interface ISubjectDropDownOption {
	label: string;
	subjectIdentifier: MiaPlaza.Model.Subject;
	state: SubjectDropDownOptionState;
}

export interface ICourseDropDownOption {
	label: string;
	courseIdentifier: string;
	state: SubjectDropDownOptionState | SeparatorOption;
}
